import { useEffect, useState } from "react";
import { getAdminGameAudit } from "../../../features/game/gameApi";

export default function AdminAuditPanel({ gameId }) {
  const [data, setData] = useState({ items: [], pagination: null });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      setLoading(true);
      try {
        const next = await getAdminGameAudit(gameId, { page: 1, limit: 15 });
        if (mounted) setData(next || { items: [], pagination: null });
      } finally {
        if (mounted) setLoading(false);
      }
    };
    if (gameId) run();
    return () => {
      mounted = false;
    };
  }, [gameId]);

  return (
    <section>
      <h3>Audit Trail</h3>
      {loading ? <p>Loading audit events…</p> : null}
      {!loading && !data?.items?.length ? <p>No audit entries yet.</p> : null}
      <ul>
        {(data?.items || []).map((item) => (
          <li key={item._id}>
            <strong>{item.actionType}</strong> — {item.summary}
          </li>
        ))}
      </ul>
    </section>
  );
}
